import { render, staticRenderFns } from "./UserProfile.vue?vue&type=template&id=15ba6136&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./UserProfile.vue?vue&type=style&index=0&id=15ba6136&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ba6136",
  null
  
)

export default component.exports